import Typography from 'components/Typography/Typography'
import { ReactComponent as HospitalIcon } from 'assets/svg/Hospital.svg'
import './styles.scss'
import { Button, BUTTON_TYPES } from 'components/Button'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import { BTN_TXT } from 'constants/txt'
import { TBusinessDetailsEmptyState } from './types'

export const BusinessDetailsCommunityEmptyState = ({
  onClick
}: TBusinessDetailsEmptyState) => (
  <div className="business-details-container__empty-state row justify-center">
    <div className="business-details-container__empty-state__wrapper column align-center">
      <HospitalIcon />
      <Typography.Headline6 className="mt-32">
        No business details added yet.
      </Typography.Headline6>
      <Typography.Paragraph className="mt-8">
        Connect your business with our secure payments partner to enable bank
        transfers, ACH, and invoicing.
      </Typography.Paragraph>
      <Button
        className="contract-categories__add-btn mt-24"
        onClick={onClick}
        icon={<Plus16 />}
        type={BUTTON_TYPES.PRIMARY}
        disabled={!onClick}
        upperCase
        medium
      >
        {BTN_TXT.ADD_BUSINESS_DETAILS}
      </Button>
    </div>
  </div>
)
